export default __webpack_public_path__ + "static/media/font.80c58755.woff";